var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "absolute top-[-180px] lg:top-[-50px] xl:top-[-180px] right-0 z-60 text-center"
    },
    _vm._l(_vm.quotes, function(quote, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass:
            "text-white first:opacity-50 last:opacity-50 selector-q lg:text-30 xl:text-50 font-thin mb-[20px] max-w-[250px] xl:max-w-[400px]",
          class: { "lg:ml-[200px] xl:ml-[300px]": index % 2 === 0 }
        },
        [_vm._v("\n        " + _vm._s(quote.text) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }